import React from 'react';
import PropTypes from 'prop-types';

function gotoProductPage(name) {
  if (name) {
    window.open(`/product/${name}`);
  }
}

class LeftMiddleRightLayout extends React.Component {
  render() {
    let { less, descMaxNum } = this.props;
    let bottomStyle = {};
    let outerStyle = {};
    let titleStyle = {};
    let descStyle = {};
    let bottomConStyle = {};
    let innerStyle = {};
    switch (this.props.list.length) {
      case 1:
        bottomConStyle.justifyContent = 'center';
        descStyle.width = '100%';
        break;
      case 2:
        descStyle.width = '340px';
        bottomConStyle.padding = '0 170px';
        break;
      case 4:
        titleStyle.width = '216px';
        descStyle.width = '216px';
        break;
      case 6:
        innerStyle.marginBottom = '40px';
        outerStyle.paddingBottom = '10px';
        break;
      default:
        break;
    }
    return (
      <div className={less.outer} style={outerStyle}>
        <div className={less.top}>{this.props.title}</div>
        <div className={less.bottom} style={bottomStyle}>
          <div className={less.bottomCon} style={bottomConStyle}>
            {this.props.list.map((item) => {
              return (
                <div
                  className={less.inner}
                  key={item.title}
                  onClick={() => gotoProductPage(item.name)}
                  style={innerStyle}
                >
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.title}
                      className={less.image}
                    />
                  )}
                  <div className={less.content}>
                    <div className={less.title} style={titleStyle}>
                      {item.title}
                    </div>
                    <div className={less.desc} style={descStyle}>
                      {item.desc.length > descMaxNum
                        ? `${item.desc.substring(0, descMaxNum)}...`
                        : item.desc}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

LeftMiddleRightLayout.propTypes = {
  descMaxNum: PropTypes.number,
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      desc: PropTypes.string,
      name: PropTypes.string
    })
  )
};

LeftMiddleRightLayout.defaultProps = {
  descMaxNum: 999
};

export default LeftMiddleRightLayout;
